// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "@ngx-translate/core";
var SubscriptionsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SubscriptionsService(apiService, helperService, translateService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.translateService = translateService;
    }
    /**
     * Create a new subscription
     *
     * @since 1.0.0
     *
     * @param subscription Subscription data
     * @returns Observable<any>
     */
    SubscriptionsService.prototype.create = function (subscription) {
        return this.apiService.apiCall('POST', 'subscriptions', subscription);
    };
    /**
     * Get subscriptions list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    SubscriptionsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'subscriptions', params);
    };
    /**
     * Get an exportation file of all subscriptions
     *
     * @since 1.0.0
     */
    SubscriptionsService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'subscriptions/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given subscriptionId data from back-end
     *
     * @since 1.0.0
     *
     * @param subscriptionId ID of the subscription to get
     */
    SubscriptionsService.prototype.get = function (subscriptionId) {
        var _this = this;
        return this.apiService.apiCall('GET', "subscriptions/" + subscriptionId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get given subscriptionKey data from back-end
     *
     * @since 1.0.0
     *
     * @param subscriptionKey ID of the subscription to get
     */
    SubscriptionsService.prototype.getByKey = function (subscriptionKey) {
        var _this = this;
        return this.apiService.apiCall('GET', "subscriptions", { subscriptionKey: subscriptionKey }).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update subscription with given subscriptionId with given subscription data
     *
     * @since 1.0.0
     *
     * @param subscriptionId ID of subscription to update
     * @param data New subscription's data
     */
    SubscriptionsService.prototype.update = function (subscriptionId, data) {
        return this.apiService.apiCall('PUT', "subscriptions/" + subscriptionId, data);
    };
    /**
     * Delete permanently a subscription
     *
     * @since 1.0.0
     *
     * @param subscriptionId ID of the subscription
     */
    SubscriptionsService.prototype.delete = function (subscriptionId) {
        return this.apiService.apiCall('DELETE', "subscriptions/" + subscriptionId);
    };
    SubscriptionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SubscriptionsService_Factory() { return new SubscriptionsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.TranslateService)); }, token: SubscriptionsService, providedIn: "root" });
    return SubscriptionsService;
}());
export { SubscriptionsService };
